export default "__VITE_ASSET__CJyBFkla__"